<template>
    <div class="home-box">
        <div class="home">
            <div class="clearfix">
                <div class="l">
                    已使用积分
                    <div class="code">
                        {{usedIntegral}}
                    </div>
                </div>
                <div class="r">
                    当前可用积分
                    <div class="code">
                        {{canUseIntegral}}
                    </div>
                </div>
            </div>
            <div class="fourB">
                <div class="lb" @click="buyCard">
                    <!--                    <div class="cj">-->
                    <img src="../assets/buyIntegral.png" style="width: 22px;height: 18px;vertical-align:middle"/>
                    &nbsp;购买积分卡
                    <!--                    </div>-->
                </div>
                <div class="lb" @click="exchange">
                    <img src="../assets/exchangeIntegral.png" style="width: 22px;height: 18px;vertical-align:middle"/>
                    &nbsp;激活积分卡
                </div>
                <div class="lb" @click="loginAdd">
                    <img src="../assets/loginIntegral.png" style="width: 22px;height: 18px;vertical-align:middle"/>
                    &nbsp;签到送积分
                </div>
                <div class="lb" @click="morePath">
                    <img src="../assets/buyMoreInteral.png" style="width: 22px;height: 18px;vertical-align:middle"/>
                    &nbsp;赚更多积分
                </div>
            </div>
            <div class="howBanner" @click="howUse">
                <img src="../assets/howBanner.png" style="height: 100%;width:100%">
            </div>
            <div class="xx">
                <div class="k">
                    <div class="kt">
                        <div class="tl">
                            积分使用明细
                        </div>
                        <div class="tr">
                            即将到账数量:{{futureIntegral}}
                        </div>
                    </div>
                    <!--                    <div >-->
                    <div class="mainI" v-for="(item,index) in list" :key="index">
                        <div class="upt">
                            {{item.updateName}}
                        </div>
                        <div class="interal">
                            <div v-if="item.integral>0">
                                +{{item.integral}}
                            </div>
                            <div v-if="item.integral<0">
                                {{item.integral}}
                            </div>
                        </div>
                        <div class="dt">
                            {{item.addTime}}
                        </div>
                        <van-divider/>
                    </div>
                    <!--                    </div>-->
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'IntegralCenter',
        props: {
            usedIntegral: Number,
            canUseIntegral: Number,
            futureIntegral: Number,
            list: Array,
            buyCard: Function,
            exchange: Function,
            loginAdd: Function,
            morePath: Function,
            howUse: Function,
        },
    }
</script>
<style>
    .home-box {
        width: 100vw;
        background-color: rgb(242, 242, 242);
        background-repeat: no-repeat;
        background-size: 100%, 100%;
        text-align: center;
    }

    .home {
        margin: 0 auto;
        width: 380px;
    }

    .clearfix {
        background-image: url("../assets/Integral.png");
        background-repeat: no-repeat;
        height: 130px;
        width: 380px;
        background-size: 100%, 100%;
    }

    .l {
        font-size: 15.67px;
        color: white;
        float: left;
        width: 50%;
        text-align: center;
        line-height: 50px;
    }

    .r {
        font-size: 15.67px;
        color: white;
        float: right;
        width: 50%;
        text-align: center;
        line-height: 50px;
    }

    .code {
        font-size: 36.13px;
        color: white;
    }

    .fourB {
        margin-top: 0px;
        background-image: url("../assets/buttonback.png");
        height: 114px;
        width: 380px;
        background-repeat: no-repeat;
        background-size: 100%, 100%;

    }

    .lb {
        font-size: 14.91px;
        float: left;
        width: 50%;
        height: 50%;
        text-align: center;
        line-height: 50px;
    }

    .howBanner {
        margin-top: 15px;
        height: 98px;
        width: 380px;
    }

    .xx {
        margin-top: 15px;
        width: 380px;
        background-color: white;
        border-radius: 10px;
    }

    .k {
        /*margin-top: 15px;*/
        margin-left: 20px;
        margin-right: 20px;
        height: 80%;
    }

    .kt {
        display: inline;
        height: 50px;
        width: 100%;
        line-height: 50px;
    }

    .tl {

        font-size: 15.33px;
        /*float: left;*/
        width: 50%;
        float: left;
        text-align: left;
        font-weight: bold;
    }

    .tr {
        font-size: 12.67px;
        line-height: 50px;
        float: right;
        text-align: right;
    }

    .mainI {
        width: 100%;
        height: 67px;
        position: relative;
        top: 10px;
        clear: left;
        text-align: left;
        /*text-align: right;*/

    }

    .upt {
        display: inline;
        font-size: 15.33px;
    }

    .dt {
        font-size: 11.67px;
    }

    .interal {
        display: inline;
        font-size: 12.67px;
        line-height: 50px;
        float: right;
        color: red;

    }

</style>



// WEBPACK FOOTER //
// src/components/IntegralCenter.vue